import Button from './button';

export default class Warning extends Button {
  get buttonClass() {
    return 'ds-button--warning';
  }
}
